// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__3jH-M","header":"Error_header__jXb78","content":"Error_content__2JZ-w"};